var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "charge-share-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("FinanceManage.charge_sp11"),
        width: "900px",
        "close-on-click-model": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "charge-share-dialog-inner" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "72px",
                "label-position": "left"
              }
            },
            [
              _vm.charges.length > 1
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { "font-weight": "bold" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("FinanceManage.allocationType")) +
                              " "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: _vm.$t("Message.ShareTypeTip"),
                                placement: "bottom-start"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  cursor: "pointer",
                                  padding: "2px 2px 0 0"
                                },
                                attrs: {
                                  src: _vm.iconQuestion,
                                  width: "13",
                                  height: "13"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.shareTypeChange },
                          model: {
                            value: _vm.shareType,
                            callback: function($$v) {
                              _vm.shareType = $$v
                            },
                            expression: "shareType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(_vm._s(_vm.$t("Message.Agreement")))
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("Message.NotAgreement")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticStyle: { "margin-right": "0" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-weight": "bold" },
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Message.AllocationNature")) + " "
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            content: _vm.$t(
                              "Message.VirtualAllocationAndActualSplitTip"
                            ),
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              cursor: "pointer",
                              padding: "2px 2px 0 0"
                            },
                            attrs: {
                              src: _vm.iconQuestion,
                              width: "13",
                              height: "13"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-radio-group",
                    {
                      attrs: { value: _vm.shareNature },
                      on: { input: _vm.onShareNatureInput }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("Message.VirtualAllocation")))
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("Message.ActualSplit")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.shareNature === 1
                ? _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.$t("Message.ActualSplitWarn")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-card",
            { attrs: { header: _vm.title, shadow: "never" } },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "grid-options": _vm.costTable.grid.gridOptions,
                  "column-defs": _vm.dynamicCostColumnDefs,
                  "row-data": _vm.charges,
                  "min-height": "150px"
                },
                on: {
                  gridReady: function(params) {
                    _vm.costTable.grid.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-card",
            {
              attrs: {
                header: _vm.$t("FinanceManage.separateAllocation"),
                shadow: "never"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { "padding-bottom": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.controlCalcButton,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.calcShareAmount()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CalcShareAmount")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { "min-height": "200px" },
                    attrs: {
                      "grid-options": _vm.sharingTable.grid.gridOptions,
                      "column-defs": _vm.dynamicSharingColumnDefs,
                      "row-data": _vm.sharingTable.grid.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.sharingTable.grid.gridApi = params.api
                      }
                    }
                  }),
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sharingDetailTable.grid.isShow,
                        expression: "sharingDetailTable.grid.isShow"
                      }
                    ],
                    staticStyle: {
                      "min-height": "200px",
                      "margin-left": "2px"
                    },
                    attrs: {
                      "grid-options": _vm.sharingDetailTable.grid.gridOptions,
                      "column-defs": _vm.dynamicShareDetailColumnDefs,
                      "row-data": _vm.sharingDetailTable.grid.rowData,
                      "show-side-bar": false
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.enterHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }